<div class="container">
  @if (initialized) {
    @if (!headings.length) {
      <div class="mat-body-strong">
        @if (!bidItem.record_by_station) {
          Record by station is not enable for this biditem
        }
        @if (!bidItem?.site && bidItem.record_by_station) {
          Select a site to show headings
        }
        @if (bidItem?.site?.id) {
          Site "{{bidItem?.site?.name}}" has no headings
        }
      </div>
    }
    <div class="list">
      @for (heading of headings; track heading) {
        <div class="list-card">
          <div class="body">
            <mat-checkbox [checked]="heading.checked" (change)="onChange(heading, $event.checked)">
              <div class="mat-body-strong">
                {{heading.name}}
                <span class="mat-caption muted">
                  {{heading.starts_from}} to {{heading.ends_at}}
                </span>
                <div class="mat-body-2">
                  {{heading.alignment_name || 'None'}}
                </div>
              </div>
            </mat-checkbox>
          </div>
        </div>
      }
    </div>
  }

</div>